import 'twin.macro';
import React from 'react';
import Button, { Props as ButtonProps } from './Button';
import Popover from '@teetsh/app/src/components/Popover';
import { Icon } from '@teetsh/app/src/components/Icons/icon';
import { Intent } from '@teetsh/app/src/components/Buttons/BaseButtonProps';
import { TrashIcon as Trash } from '@heroicons/react/20/solid';
import { useTranslation } from 'react-i18next';

interface Props {
  withConfirmation?: boolean;
  confirmationText?: string;
  confirmationIcon?: Icon | 'none';
  popoverText?: string | React.ReactNode;
  buttonText?: string | React.ReactNode;
  confirmationButtonProps?: ButtonProps;
  'aria-label'?: string;
  portal?: boolean;
}

export default function DeleteButton(props: Props & ButtonProps) {
  const {
    withConfirmation,
    popoverText,
    confirmationText,
    confirmationIcon,
    onClick,
    confirmationButtonProps = { small: true, intent: 'danger' },
    buttonText,
    portal = true,
    ...rest
  } = props;
  const buttonProps = {
    onClick: withConfirmation ? e => e.stopPropagation() : onClick,
    'aria-label': props['aria-label'] || 'delete-button',
    intent: 'danger' as Intent,
    ...rest,
  };
  const { t } = useTranslation(['common']);
  const actionButtonText = buttonText || props.children || '';
  const confirmationButtonIcon =
    confirmationIcon === 'none' || confirmationButtonProps.intent !== 'danger'
      ? null
      : confirmationIcon || Trash;
  if (withConfirmation) {
    return (
      <Popover fill={buttonProps.fill} portal={portal}>
        <Popover.Button {...buttonProps}>{actionButtonText}</Popover.Button>
        <Popover.Panel size="xl">
          <div id="delete-panel-warning" tw="p-3">
            <div tw="mb-2">
              {popoverText ||
                t('common:components.buttons.confirmDeleteQuestion')}
            </div>
            <div tw="text-center">
              <Button
                intent="danger"
                onClick={onClick}
                icon={confirmationButtonIcon}
                {...confirmationButtonProps}
              >
                {confirmationText || t('common:buttons.confirmDelete')}
              </Button>
            </div>
          </div>
        </Popover.Panel>
      </Popover>
    );
  }
  return <Button {...buttonProps}>{buttonText}</Button>;
}
